import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Calls from "@/pages/Calls";
import Agents from "@/pages/Agents";
import AgentScorecard from "@/pages/AgentScorecard";
import Texts from "@/pages/Texts";
import Anomalies from "@/pages/Anomalies";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import UsersPage from "@/pages/Users";
import { Loading } from "@/components/common";

function Protected({ children, admin = false }) {
  const { user, isAdmin } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><Loading label="Checking session" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Overview />} />
              <Route path="/calls" element={<Calls />} />
              <Route path="/texts" element={<Texts />} />
              <Route path="/agents" element={<Protected admin><Agents /></Protected>} />
              <Route path="/agents/:id" element={<Protected admin><AgentScorecard /></Protected>} />
              <Route path="/anomalies" element={<Protected admin><Anomalies /></Protected>} />
              <Route path="/reports" element={<Protected admin><Reports /></Protected>} />
              <Route path="/users" element={<Protected admin><UsersPage /></Protected>} />
              <Route path="/settings" element={<Protected admin><Settings /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors toastOptions={{ style: { background: "#111827", border: "1px solid #2d3d58", color: "#f1f5f9" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
